/**
 * Returns a random element from an array.
 */
const random = (arr) => arr[Math.floor(Math.random() * arr.length)];

export default random;
